jQuery(function ($) {
  //------------ LOGIN -------------------------------------------------------
  const modals = document.querySelectorAll(".modal");
  const triggers = document.querySelectorAll(".login-trigger");
  const closeButton = document.querySelectorAll(".close-login-button");

  function showDialog() {
    modals.forEach((modal) => {
      modal.classList.add("show-modal");
      modal.classList.remove("invisible");
      modal.classList.remove("opacity-0");
    });
    document.body.style.overflow = "hidden";
  }

  function closeDialog() {
    modals.forEach((modal) => {
      modal.classList.remove("show-modal");
      modal.classList.add("invisible");
      modal.classList.add("opacity-0");
    });
    document.body.style.overflow = "auto";
  }

  function toggleModal() {
    modals.forEach((modal) => {
      modal.classList.toggle("show-modal");
    });

    if (modals[0].classList.contains("show-modal")) {
      closeDialogRegister();
      showDialog();
    } else {
      closeDialog();
    }
  }

  function windowOnClick(event) {
    modals.forEach((modal) => {
      if (event.target === modal) {
        toggleModal();
      }
    });
  }


  for (let i = 0; i < triggers.length; i++) {
    triggers[i].addEventListener("click", toggleModal);
  }


  closeButton.forEach((button) => {
    button.addEventListener("click", toggleModal);
  });
  window.addEventListener("click", windowOnClick);

  //------------ end LOGIN -------------------------------------------------------

  //------------ NEWSLETTER -------------------------------------------------------
  const modalNews = document.querySelectorAll(".modal-news");
  const triggersNews = document.querySelectorAll(".news-trigger");
  const closeButtonNews = document.querySelectorAll(".close-news-button");

  function showDialogNews() {
    modalNews.forEach((modal) => {
      modal.classList.add("show-modal-news");
      modal.classList.remove("invisible");
      modal.classList.remove("opacity-0");
    });

    document.body.style.overflow = "hidden";
  }

  function closeDialogNews() {
    modalNews.forEach((modal) => {
      modal.classList.remove("show-modal-news");
      modal.classList.add("invisible");
      modal.classList.add("opacity-0");
    });

    document.body.style.overflow = "auto";
  }

  function toggleModalNews() {
    modalNews.forEach((modal) => {
      modal.classList.toggle("show-modal-news");
    });
    if (modalNews[0].classList.contains("show-modal-news")) {
      showDialogNews();
    } else {
      closeDialogNews();
    }
  }

  function windowOnClickNews(event) {
    modalNews.forEach((modal) => {
      if (event.target === modalNews) {
        toggleModalNews();
      }
    });
  }

  for (let i = 0; i < triggersNews.length; i++) {
    triggersNews[i].addEventListener("click", toggleModalNews);
  }

  closeButtonNews.forEach((button) => {
    button.addEventListener("click", toggleModalNews);
  });

  window.addEventListener("click", windowOnClickNews);

  //------------ end NEWSLETTER -------------------------------------------------------

  //------------ FORGET PASSWORD -------------------------------------------------------
  const modalForget = document.querySelectorAll(".modal-forget");
  const triggersForget = document.querySelectorAll(".forget-trigger");
  const closeButtonForget = document.querySelectorAll(".close-forget-button");

  function showDialogForget() {
    modalForget.forEach((modal) => {
      modal.classList.add("show-modal-news");
      modal.classList.remove("invisible");
      modal.classList.remove("opacity-0");
    });
    document.body.style.overflow = "hidden";
  }

  function closeDialogForget() {
    modalForget.forEach((modal) => {
      modal.classList.remove("show-modal-news");
      modal.classList.add("invisible");
      modal.classList.add("opacity-0");
    });
    document.body.style.overflow = "auto";
  }


  function toggleModalForget() {
    modalForget.forEach((modal) => {
      modal.classList.toggle("show-modal-news");
    });

    if (modalForget[0].classList.contains("show-modal-news")) {
      closeDialog();
      showDialogForget();
    } else {
      closeDialogForget();
    }
  }

  function windowOnClickForget(event) {
    modalForget.forEach((modal) => {
      if (event.target === modal) {
        toggleModalForget();
      }
    });
  }

  for (let i = 0; i < triggersForget.length; i++) {
    triggersForget[i].addEventListener("click", toggleModalForget);
  }

  closeButtonForget.forEach((button) => {
    button.addEventListener("click", toggleModalForget);
  });
  window.addEventListener("click", windowOnClickForget);

  //------------ end FORGET PASSWORD -------------------------------------------------------


  //register
  const modalRegister = document.querySelectorAll(".modal-register");
  const triggersRegister = document.querySelectorAll(".register-trigger");
  const closeButtonRegister = document.querySelectorAll(".close-register-button");


  function showDialogRegister() {
    modalRegister.forEach((modal) => {
      modal.classList.add("show-modal-news");
      modal.classList.remove("invisible");
      modal.classList.remove("opacity-0");
    });
    document.body.style.overflow = "hidden";
  }

  function closeDialogRegister() {
    modalRegister.forEach((modal) => {
      modal.classList.remove("show-modal-news");
      modal.classList.add("invisible");
      modal.classList.add("opacity-0");
    });
    document.body.style.overflow = "auto";
  }

  function toggleModalRegister() {
    modalRegister.forEach((modal) => {
      modal.classList.toggle("show-modal-news");
    });

    if (modalRegister[0].classList.contains("show-modal-news")) {
      closeDialog();
      showDialogRegister();
    } else {
      closeDialogRegister();
    }
  }

  function windowOnClickRegister(event) {
    modalRegister.forEach((modal) => {
      if (event.target === modal) {
        toggleModalRegister();
        $('#register_user').show();
        $('.register-success').hide();
      }
    });
  }

  for (let i = 0; i < triggersRegister.length; i++) {
    triggersRegister[i].addEventListener("click", toggleModalRegister);
  }

  closeButtonRegister.forEach((button) => {
    button.addEventListener("click", toggleModalRegister);
  });


  window.addEventListener("click", windowOnClickRegister);


}); //js

